import { useQuery } from '@tanstack/react-query';

import { systemApi } from 'api/system';
import { ApiError } from 'shared/errors/ApiError';

export const ELOGII_TASK_SUMMARY_QUERY_KEY = 'elogiiTaskSummary';

export const elogiiTaskSummaryQueryKeys = {
    all: [ELOGII_TASK_SUMMARY_QUERY_KEY],
    byTaskId: (taskId) => [ELOGII_TASK_SUMMARY_QUERY_KEY, taskId],
};

export const useGetElogiiTaskSummaryQuery = (taskId, { enabled = true } = {}) =>
    useQuery({
        enabled: !!taskId && enabled,
        queryFn: async () => {
            const response = await systemApi.getElogiiTaskByTaskId(taskId);
            if (!response?.status) {
                throw new ApiError(
                    response?.msg ?? 'Failed to fetch Elogii task summary',
                    response?.statusCode,
                    response?.data,
                );
            }

            return response.data;
        },
        queryKey: elogiiTaskSummaryQueryKeys.byTaskId(taskId),
        retry: (failureCount, error) => {
            if (error instanceof ApiError && (error.isClientError || error.isServerError)) {
                return false;
            }

            return failureCount <= 1;
        },
    });
